import { useMutation } from '@tanstack/react-query'
import { deleteFormDefinitionFormsFormDefinitionIdDelete } from '@common/config/api/client/services.gen'

export default function useDeleteFormDefinition() {
  return useMutation({
    mutationFn: (formId: string) =>
      deleteFormDefinitionFormsFormDefinitionIdDelete({ path: { form_definition_id: formId } }),
  })
}
